import React from "react";

const MessageContext = React.createContext(null);

export default MessageContext;
